<template>
  <div class="bigBox">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
import { getSignatureInfo } from "@/api/index";
export default {
  name: "Index",
  provide() {
    return {
      Index: this,
      path: "",
      signatureInfo: {},
    };
  },
  components: {},
  data() {
    return {
      hansappid: "",
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.path = encodeURIComponent(window.location.href.split("#")[0]);
      //   this.path = encodeURIComponent(window.location.href);
      //   this.path = window.location.href.split("#")[0];
      //   this.path = window.location.href;
      //   this.path =
      //     window.location.href.split("#")[0] + window.location.href.split("#")[1];

      //   this.$dialog
      //     .alert({
      //       title: "path",
      //       message: this.path,
      //     })
      //     .then(() => {
      //       // this.$router.back();
      //     });
      this.hansappid = sessionStorage.getItem("hansappid");

      getSignatureInfo(
        new Object({
          hansappid: this.hansappid,
          url: this.path,
        })
      )
        .then((res) => {
          this.signatureInfo = res.data.data;
          let config = {
            // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出
            debug: false,
            appId: this.signatureInfo.hansappid, // 必填，公众号的唯一标识
            timestamp: this.signatureInfo.timestamp, // 必填，生成签名的时间戳
            nonceStr: this.signatureInfo.noncestr, // 必填，生成签名的随机串
            signature: this.signatureInfo.signature, // 必填，签名
            jsApiList: [
              "checkJsApi",
              "updateAppMessageShareData",
              "getLocation",
              "openLocation",
              "chooseImage",
              "previewImage",
              "getLocalImgData",
              "uploadImage",
              "downloadImage"
            ], // 必填，需要使用的JS接口列表
          };
          //配置SDK
          this.$wx.config(config);
          this.$wx.ready(function () {
            console.log("js-sdk配置成功！");            
          });

          /**
           *通过error接口处理失败验证
           *config信息验证失败会执行error函数，如签名过期导致验证失败，
           *具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，
           *对于SPA可以在这里更新签名
           */
          this.$wx.error(function (res) {
            console.log("config信息验证失败", res);
          });
          // 判断当前客户端版本是否支持指定 JS 接口
          this.$wx.checkJsApi({
            jsApiList: ["getLocalImgData"], // 需要检测的 JS 接口列表，所有 JS 接口列表见附录2,
            success: function (res) {
              console.log("检测接口是否可用", res);
              // alert(toString(res))
              // 以键值对的形式返回，可用的 api 值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            },
          });
        })
        .catch((err) => {
          console.log("获取签名失败-----》", err);
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/page/layIndex.vue